import { toast } from "react-toastify";

export const confirmToast = (message, onConfirm, onCancel) => {
    toast(
        ({ closeToast }) => (
            <div>
                <p className="mb-2">{message}</p>
                <div className="d-flex justify-content-end gap-2">
                    <button
                        className="btn btn-sm btn-danger"
                        onClick={() => {
                            onConfirm && onConfirm();
                            closeToast();
                        }}
                    >
                        Yes
                    </button>
                    <button
                        className="btn btn-sm btn-secondary"
                        onClick={() => {
                            onCancel && onCancel();
                            closeToast();
                        }}
                    >
                        Cancel
                    </button>
                </div>
            </div>
        ),
        {
            autoClose: false,
            closeOnClick: false,
            draggable: false,
        }
    );
};
